import React from 'react';
import { translate } from 'admin-on-rest';
import StarIcon from 'material-ui/svg-icons/toggle/star';
import StarRatingField from '../review/StarRatingField';

const styles = {
    card:    { background: '#fff', borderRadius: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.05), 0 1px 2px rgba(0,0,0,0.03)', overflow: 'hidden' },
    header:  { padding: '12px 16px', borderBottom: '1px solid #f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
    title:   { fontSize: 13, fontWeight: 700, color: '#111827', letterSpacing: 0.2, display: 'flex', alignItems: 'center', gap: 8 },
    badge:   { fontSize: 11, color: '#6b7280', background: '#f3f4f6', padding: '2px 8px', borderRadius: 999, fontWeight: 600 },
    listWrap:{ maxHeight: 360, overflowY: 'auto' },
    row:     { padding: '10px 16px', borderBottom: '1px solid #f9fafb', fontSize: 12 },
    subj:    { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 },
    subject: { fontWeight: 700, color: '#111827', fontSize: 13 },
    review:  { color: '#4b5563', fontStyle: 'italic', lineHeight: 1.4, marginBottom: 4 },
    meta:    { fontSize: 11, color: '#9ca3af' },
    empty:   { padding: 24, textAlign: 'center', color: '#9ca3af', fontSize: 12 },
};

export default translate(({ reviews = [], nb }) => (
    <div style={styles.card}>
        <div style={styles.header}>
            <span style={styles.title}>
                <StarIcon style={{ width: 14, height: 14, color: '#fd9512' }} />
                {nb}
            </span>
            <span style={styles.badge}>{reviews.length}</span>
        </div>
        <div style={styles.listWrap}>
            {reviews.length === 0 && <div style={styles.empty}>Geen reviews</div>}
            {reviews.map((record) => (
                <div key={record.id} style={styles.row}>
                    <div style={styles.subj}>
                        <span style={styles.subject}>{record.subject}</span>
                        <StarRatingField rating={record.rating} />
                    </div>
                    <div style={styles.review}>{record.review}</div>
                    <div style={styles.meta}>{record.site_source} · {new Date(record.created_at).toLocaleDateString('nl-NL')}</div>
                </div>
            ))}
        </div>
    </div>
));



// WEBPACK FOOTER //
// ./src/dashboard/ReviewsList.js